import PropTypes from "prop-types"
import React from "react"
import { CalendarButton, CalendarButtonSelected } from "./calendar-styled"
import {
  toolbarContainer,
  calendarButtonSelected,
  calendarButton,
} from "./event-calendar.module.scss"

const navigate = {
  PREVIOUS: "PREV",
  NEXT: "NEXT",
  TODAY: "TODAY",
  DATE: "DATE",
}
const CustomToolbar = ({ onNavigate, onView, view, views, label }) => {
  const navigateFunc = (action) => {
    onNavigate(action)
  }

  const viewFunc = (choosenView) => {
    onView(choosenView)
  }

  const viewNamesGroup = (viewFinal) => {
    const viewNames = views
    const finalView = viewFinal

    if (viewNames.length > 1) {
      return viewNames.map((name) => {
        const viewValues =
          name === "month"
            ? "Mois"
            : name === "week"
            ? "Semaine"
            : name === "day"
            ? "Jour"
            : name === "agenda"
            ? "Agenda"
            : null
        if (finalView === name) {
          return (
            <CalendarButtonSelected
              className={calendarButtonSelected}
              type="button"
              key={name}
              onClick={viewFunc.bind(null, name)}
            >
              {viewValues}
            </CalendarButtonSelected>
          )
        }
        return (
          <CalendarButton
            className={calendarButton}
            type="button"
            key={name}
            onClick={viewFunc.bind(null, name)}
          >
            {viewValues}
          </CalendarButton>
        )
      })
    }
  }
  return (
    <div className={toolbarContainer}>
      <span className="rbc-btn-group">
        <CalendarButton
          className={calendarButton}
          type="button"
          onClick={navigateFunc.bind(null, navigate.PREVIOUS)}
        >
          Précédent
        </CalendarButton>
        <CalendarButton
          className={calendarButton}
          type="button"
          onClick={navigateFunc.bind(null, navigate.TODAY)}
        >
          Aujourd&apos;hui
        </CalendarButton>
        <CalendarButton
          className={calendarButton}
          type="button"
          onClick={navigateFunc.bind(null, navigate.NEXT)}
        >
          Suivant
        </CalendarButton>
      </span>

      <span className="rbc-toolbar-label">{label}</span>

      <span className="rbc-btn-group">{viewNamesGroup(view)}</span>
    </div>
  )
}

CustomToolbar.propTypes = {
  view: PropTypes.string.isRequired,
  views: PropTypes.arrayOf(PropTypes.string).isRequired,
  label: PropTypes.node.isRequired,
  localizer: PropTypes.object,
  onNavigate: PropTypes.func.isRequired,
  onView: PropTypes.func.isRequired,
}

export default CustomToolbar
